import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Offset} from '../../../models/Offset';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ConsuntivoVolumiScartoService} from './service-consuntivo-volumi-scarto/consuntivo-volumi-scarto.service';
import {ScartiConsuntivoVolumiModel} from '../../../models/ScartiConsuntivoVolumiModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {Router} from '@angular/router';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {ProviderModel} from '../../../models/ProviderModel';

@Component({
  selector: 'app-consuntivo-volumi-scarto',
  templateUrl: './consuntivo-volumi-scarto.component.html',
  styleUrls: ['./consuntivo-volumi-scarto.component.scss']
})
export class ConsuntivoVolumiScartoComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  getFirtsYearSubscribe: Subscription;
  getFirtsYearObservable: Observable<any>;

  displayedColumns: Array<string>;
  dataSource: any;
  showFilter: boolean;
  listData: MatTableDataSource<any>;
  offset: Offset;
  filter: any;
  numAnnoMeseData: any;

  providerSelected: ProviderModel;

  isConsumptiveWasteSection: boolean;
  selectedRowIndex: number;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() reportSection?: boolean;
  @Output() elementSelected = new EventEmitter();


  constructor(private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private consuntivoVolumiScartoService: ConsuntivoVolumiScartoService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;


    if (this.providerSelected.description === this.PROVIDER_IBM) {
      this.displayedColumns = ['regionCod', 'localCustomerCod', 'contractCod',
        'resourcesUnitCod', 'designServicesCod', 'layerCod', 'l1Cod', 'l2Cod', 'l3Cod',
        'subsidary', 'serialNumber', 'slaType', 'ssru', 'actualQuantity',
        'unit', 'shareName',
        'applicationCod', 'applicationDescription', 'errors', 'actions'];
    } else {
      this.displayedColumns = ['serviceDate', 'regionCod', 'localCustomerCod', 'contractCod',
        'resourcesUnitCod', 'designServicesCod', 'layerCod', 'l1Cod', 'l2Cod', 'l3Cod',
        'unit', 'applicationCod', 'applicationDescription',
        'serviceVariantCod', 'serviceVariantName', 'size', 'site',
        'numAnnoMeseAcceptance', 'ulbStatus', 'requestId', 'requestDescription',
        'instanceName', 'systemName', 'monthlyForecastQuantity', 'approverRequestor',
        'deviceNameServerName', 'actualQuantity', 'errors', 'actions'];
    }
    this.filter = null;
  }

  ngOnInit() {
    this.isConsumptiveWasteSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_VOLUMI_OFFSET);
    this.filter = new ScartiConsuntivoVolumiModel();
    this.getFirtsYearObservable = this.numAnnoMeseService.getAllMonth(new ContractTypeModel()).pipe();
    this.manageForkJoin(this.getFirtsYearObservable, this.offset);
  }

  manageForkJoin(getFirtsYearSubscribe: Observable<any>, offset: Offset) {
    this.loaderService.display(false);
    forkJoin([getFirtsYearSubscribe]).subscribe(
      (resultFork: any) => {

        this.numAnnoMeseData = resultFork[0];
        const numAnnoMese = resultFork[0] ? resultFork[0][0] : null;

        this.filter.numAnnoMese = numAnnoMese;
        if (!this.reportSection) {
          this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }      }, error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

  getDataPage(offset: Offset, filter: ScartiConsuntivoVolumiModel) {
            this.getPageSubscribe = this.consuntivoVolumiScartoService.getPage(offset, filter)
              .subscribe(
                (resultPage: any) => {
                  this.dataSource = resultPage.content;
                  this.listData = new MatTableDataSource(this.dataSource);
                  this.paginator.pageIndex = offset.pageIndex;
                  this.paginator.showFirstLastButtons = true;
                  this.paginator.length = resultPage.totalElements;
                  this.listData.sort = this.sort;
                  this.loaderService.display(false);
                });
  }

  openDialog(id: number) {
    const consuntivoVolumi = this.dataSource.find(data => data.id === id) as ScartiConsuntivoVolumiModel;

    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consuntivoVolumi.numAnnoMese)},
      {id: 'Reference Month ', value: this.toCustomStringAnnoMese(consuntivoVolumi.numAnnoMeseRif)},
      {id: 'Provider Cod', value: this.toCustomString(consuntivoVolumi.providerCod)},
      {id: 'Region Cod', value: this.toCustomString(consuntivoVolumi.regionCod)},
      {id: 'Local Customer Cod', value: this.toCustomString(consuntivoVolumi.localCustomerCod)},
      {id: 'Contract Type Cod', value: this.toCustomString(consuntivoVolumi.contractCod)},
      {id: 'Resource Unit Cod', value: this.toCustomString(consuntivoVolumi.localCustomerCod)},
      {id: 'SL1 Cod', value: this.toCustomString(consuntivoVolumi.localCustomerCod)},
      {id: 'ShareName', value: this.toCustomString(consuntivoVolumi.shareName)},
      {id: 'Errors', value: this.toCustomString(consuntivoVolumi.errors)},
      {id: 'SL1 Cod', value: this.toCustomString(consuntivoVolumi.designCod)},
      {id: 'SL2 Cod', value: this.toCustomString(consuntivoVolumi.layerCod)},
      {id: 'SL3 Cod', value: this.toCustomString(consuntivoVolumi.l1Cod)},
      {id: 'SL4 Cod', value: this.toCustomString(consuntivoVolumi.l2Cod)},
      {id: 'SL5 Cod', value: this.toCustomString(consuntivoVolumi.l3Cod)},
      {id: 'Subsidary', value: this.toCustomString(consuntivoVolumi.subsidary)},
      {id: 'Serial Number', value: this.toCustomString(consuntivoVolumi.serialNumber)},
      {id: 'Sla Type', value: this.toCustomString(consuntivoVolumi.slaType)},
      {id: 'Ssru', value: this.toCustomString(consuntivoVolumi.ssru)},
      {id: 'Volume', value: this.toCustomString(consuntivoVolumi.vol)},
      {id: 'Unit', value: this.toCustomString(consuntivoVolumi.unit)},
      {id: 'Application Cod', value: this.toCustomString(consuntivoVolumi.applicationCod)},
      {id: 'Application Description', value: this.toCustomString(consuntivoVolumi.applicationDescription)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_VOLUMI_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

    getDataFiltered(dataFiltered: any) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }
      this.filter = dataFiltered;
      if (!this.reportSection) {
        this.getDataPage(this.offset, this.filter);
      }    }

    sortData(sort: Sort) {
      this.loaderService.display(true);
      if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
        if (this.offset === null || this.offset === undefined) {
          this.offset = new Offset(10, 0);
        }

        this.offset.orderField = sort.active;
        this.offset.orderDirection = sort.direction;

        this.getDataPage(this.offset, this.filter);
      }

    }

    selectRow(row: any) {
      this.selectedRowIndex = row.id;
      this.elementSelected.emit({ row });
    }

    ngOnDestroy(): void {
        if (this.getPageSubscribe) {
        this.getPageSubscribe.unsubscribe();
      }
      if (this.deleteElementSubscribe) {
        this.deleteElementSubscribe.unsubscribe();
      }
    }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

 }
